import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'datesAssignements',
  type: 'node--date_assignement',
  attributes: {
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    firmaDeseada: {
      type: 'date',
      required: false,
      isArray: false,
      name: 'f_firma_deseada',
    },
    firmaFinanciera: {
      type: 'date',
      required: false,
      isArray: false,
      name: 'f_firma_financiera',
    },
    fechaEntrada: {
      type: 'date',
      required: false,
      isArray: false,
      name: 'f_entrada',
    },
    fechaFirmaCancelacion: {
      type: 'dateTime',
      required: false,
      isArray: false,
      name: 'f_firma_cancelacion',
    },
    fechaFirmaNotario: {
      type: 'datetime',
      required: false,
      isArray: false,
      name: 'f_firma_notario',
    },
  },
  relationships: {
    analista: {
      type: 'node--employee',
      required: false,
      isArray: false,
      name: 'analista',
    },
    analistaDRC: {
      type: 'node--employee',
      required: false,
      isArray: false,
      name: 'analista_drc',
    },
    cancela: {
      type: 'node--employee',
      required: false,
      isArray: false,
      name: 'cancela',
    },
    colaborador: {
      type: 'node--collaborator',
      required: false,
      isArray: false,
      name: 'colaborador',
    },
    comercial: {
      type: 'node--employee',
      required: false,
      isArray: false,
      name: 'comercial',
    },
    financiero: {
      type: 'node--employee',
      required: false,
      isArray: false,
      name: 'financiero',
    },
    formaliza: {
      type: 'node--employee',
      required: false,
      isArray: false,
      name: 'formaliza',
    },
    juridico: {
      type: 'node--employee',
      required: false,
      isArray: false,
      name: 'juridico',
    },
  },
};
export const DatesAssignementsService = createService(base, configuration, API_CONFIG.API);
export const DatesAssignementsModule = createModule(DatesAssignementsService, true);



// WEBPACK FOOTER //
// ./src/models/datesAssigments.js